import { RateAdjustmentOptions } from '@app/modules/payslip-payment-items/constants';
import isFunction from 'lodash-es/isFunction';

inputRateAdjustmentDirective.$inject = [];

export function inputRateAdjustmentDirective() {
    return {
        // language=HTML
        template: `
            <div class="form-row">
                <app-input-select class="flex-33"
                                  label="Rate adjustment"
                                  hint="{{ hint }}"
                                  value="type">
                    <md-option ng-value="rateAdjustmentOptions.none">None</md-option>
                    <md-option ng-value="rateAdjustmentOptions.discount">Discount</md-option>
                    <md-option ng-value="rateAdjustmentOptions.markup">Mark-up</md-option>
                </app-input-select>

                <app-input-number class="flex-33"
                                  label="Discount (%)"
                                  ng-show="type === rateAdjustmentOptions.discount"
                                  name="discount_percentage"
                                  min="0"
                                  max="100"
                                  step="0.01"
                                  value="value.discount_percentage">
                </app-input-number>

                <app-input-number class="flex-33"
                                  label="Mark-up (%)"
                                  ng-show="type === rateAdjustmentOptions.markup"
                                  name="mark_up_percentage"
                                  min="0"
                                  max="400"
                                  step="0.01"
                                  value="value.mark_up_percentage">
                </app-input-number>
            </div>

            <app-alert warn
                       icon="error"
                       ng-if="markUpWarning && (type === rateAdjustmentOptions.markup) && (value.mark_up_percentage > 0)">
                {{ markUpWarning }}
            </app-alert>

            <app-alert warn
                       icon="error"
                       ng-if="notPaidWarning && (type === rateAdjustmentOptions.discount) && (value.discount_percentage === 100)">
                {{ notPaidWarning }}
            </app-alert>
        `,
        scope: {
            dispatchChange: '&?change',
            hint: '@hint',
            markUpWarning: '@markUpWarning',
            notPaidWarning: '@notPaidWarning',
            value: '=value',
        },
        link: function (scope) {
            scope.rateAdjustmentOptions = {
                none: RateAdjustmentOptions.none,
                discount: RateAdjustmentOptions.discount,
                markup: RateAdjustmentOptions.markup,
            };

            scope.type = RateAdjustmentOptions.none;

            scope._updateRateFactor = _updateRateFactor;

            scope.$watch('value.mark_up_percentage', (newValue, oldValue) => {
                if (newValue !== oldValue) {
                    _updateRateFactor();
                }
            });

            scope.$watch('value.discount_percentage', (newValue, oldValue) => {
                if (newValue !== oldValue) {
                    _updateRateFactor();
                }
            });

            scope.$watch('type', (newValue, oldValue) => {
                if (newValue !== oldValue) {
                    _updateRateFactor();
                }
            });

            setupRateAdjustment();

            function setupRateAdjustment() {
                scope.type = calculateRateAdjustment(scope.value.rate_factor_percentage);
            }

            function _updateRateFactor() {
                scope.value.rate_factor_percentage = calculateRateFactor(
                    scope.type,
                    scope.value
                );
                _onChange();
            }

            /**
             * Calculate the rate factor percentage
             */
            function calculateRateFactor(type, allocation) {
                if (type === RateAdjustmentOptions.markup) {
                    return 100 + allocation.mark_up_percentage;
                }
                if (type === RateAdjustmentOptions.discount) {
                    return 100 - allocation.discount_percentage;
                }
                return null;
            }

            /**
             * Calculate the rate adjustment type
             */
            function calculateRateAdjustment(rateFactor) {
                if (rateFactor > 100) {
                    return RateAdjustmentOptions.markup;
                }
                if (rateFactor < 100 && rateFactor !== null) {
                    return RateAdjustmentOptions.discount;
                }
                return RateAdjustmentOptions.none;
            }

            function _onChange() {
                if (isFunction(scope.dispatchChange)) {
                    scope.dispatchChange({
                        value: scope.value,
                    });
                }
            }
        },
    };
}
